import includes from 'lodash/includes'
import { useUserStore } from '@/store/userStore'

export default function ({ store, redirect }) {
  const userStore = useUserStore()

  if (userStore.loggedIn && !isAdmin(store.state.users.user)) {
    return redirect('/forbidden')
  }
}

// Vistas abiertas solo para 'superadmin', 'admin', 'editor' - Operadores no ven éstas vistas
function isAdmin(user) {
  return user && user.role && includes(['superadmin', 'admin'], user.role)
}
